import React, { Component } from "react";
import { connect } from "react-redux";
import { trim } from "lodash";
import {
  Text,
  Image,
  Linking,
  TouchableOpacity,
  KeyboardAvoidingView,
} from "react-native";

import { Background, Card, Input, Button, Loader, SnackBar } from "components";
import { UpdateModal } from "utils";

import {
  getOrganization,
  setOrganizationSlug,
} from "state/modules/organization";
import { HELP_DESK_URL } from "apis";
import { login } from "state/modules/taker";
import { isLoading } from "state/modules/loading";
import { getError } from "state/modules/error";
import { GET_ORGANIZATION } from "state/modules/organization/types";
import { POST_LOGIN } from "state/modules/taker/types";

import { styles } from "./styles";

const logo = require("assets/images/sentimeter-logo.png");

class Login extends Component {
  state = { password: "", username: "", code: null };

  render = () => {
    const { setOrganizationSlug, isOrganizationVerified, slug } = this.props;
    const { isLoading, use2FA } = this.props;
    const { username, password, code } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    return (
      <Background style={styles.background}>
        <Card style={styles.card}>
          <KeyboardAvoidingView
            onLayout={() => this.forceUpdate()}
            style={styles.container}
            behavior="padding"
          >
            <Image source={logo} resizeMode="contain" style={styles.logo} />
            <Text style={styles.tagLine}>
              Crafting better customer experience to drive your business growth
            </Text>
            <>
              {!use2FA && (
                <Input
                  placeholder="ORGANIZATION"
                  value={slug}
                  onChangeText={o => setOrganizationSlug(o)}
                  editable={!isOrganizationVerified}
                  autoCapitalize="none"
                />
              )}
              {isOrganizationVerified && (
                <>
                  {use2FA ? (
                    <Input
                      value={code}
                      placeholder="SMS Code"
                      autoCapitalize="none"
                      onChangeText={c => this.setState({ code: c })}
                    />
                  ) : (
                    <>
                      <Input
                        value={username}
                        placeholder="USERNAME"
                        autoCapitalize="none"
                        onChangeText={username =>
                          this.setState({ username: trim(username) })
                        }
                      />
                      <Input
                        value={password}
                        secureTextEntry
                        placeholder="PASSWORD"
                        autoCapitalize="none"
                        onChangeText={password => this.setState({ password })}
                      />
                    </>
                  )}
                </>
              )}
            </>
            {this.renderButton()}
          </KeyboardAvoidingView>
        </Card>
        <TouchableOpacity
          onPress={() => Linking.openURL(HELP_DESK_URL)}
          style={styles.helpArea}
        >
          <Text style={styles.helpText}>
            For Quries and Support{" "}
            <Text style={styles.helpLinkText}>click here</Text>
          </Text>
        </TouchableOpacity>
        {this.renderSnackBar()}
        <UpdateModal />
      </Background>
    );
  };

  renderSnackBar = () => {
    if (this.props.error) {
      return <SnackBar message={this.props.error} />;
    }
    return <></>;
  };

  renderButton = () => {
    const { getOrganization, isOrganizationVerified, slug, login } = this.props;
    const { use2FA } = this.props;
    const { username, password, code } = this.state;

    let label = "VERIFY";
    let onPress = () => getOrganization(slug);

    if (isOrganizationVerified) {
      label = "LOGIN";
      onPress = () => login(username, password);
    }

    if (use2FA) {
      label = "SUBMIT";
      onPress = () => login(username, password, code);
    }

    return (
      <>
        <Button color={"#ea0000"} text={label} onPress={onPress} />
        {use2FA && (
          <Button
            color={"#ea0000"}
            text="Resend"
            onPress={() => {
              login(username, password);
              this.setState({ code: null });
            }}
          />
        )}
      </>
    );
  };
}

const mapDispatchToProps = {
  getOrganization,
  setOrganizationSlug,
  login,
};

const mapStateToProps = state => {
  return {
    isLoading: isLoading(state, [GET_ORGANIZATION, POST_LOGIN]),
    error: getError(state, [GET_ORGANIZATION, POST_LOGIN]),
    slug: state.organization.slug,
    isOrganizationVerified: !!state.organization.id,
    use2FA: state.taker.use2FA,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
